<div class="sponsor">
    <ng-container *ngIf="sponsor.sponsorUrl; else defaultSponsor">
        <a class="sponsor-url" [href]="sponsor.sponsorUrl" target="_blank">
            <img title="Visit Sponsor Page" [src]="imageUrl" class="align-center" [alt]="sponsor.name"/>
        </a>
        <div class="sponsor-name" *ngIf="sponsor.name">{{sponsor.name}}</div>
    </ng-container>
    <ng-template #defaultSponsor>
        <img [src]="imageUrl" class="align-center" [alt]="sponsor.name"/>
        <div *ngIf="sponsor.name" [title]="sponsor.name" class="sponsor-name" >{{sponsor.name}}</div>
    </ng-template>
</div>